import { HeaderCell } from 'components/data_table/HeaderCell';
import { StyledHeaderCell } from 'components/data_table/styled';
import { BaseTableHeaderFooter, TableProps } from 'components/data_table/types';
import { RefObject } from 'react';

export type TableHeaderProps<TData> = BaseTableHeaderFooter<TData> &
    Pick<TableProps<TData>, 'sort' | 'onSortChange'> &
    Readonly<{
        /**
         * List of refs for the `th` elements.
         */
        headerRefs: RefObject<HTMLTableHeaderCellElement>[];
        /**
         * Callback for when a column header cell's width changes.
         */
        onResize: () => void;
    }>;

export function TableHeader<TData>({
    columns,
    tableStyle,
    sort,
    onSortChange,
    headerRefs,
    isCompact,
    primaryColumns,
    lockStyles,
    onResize,
}: TableHeaderProps<TData>) {
    return (
        <thead>
            <tr>
                {isCompact ? (
                    <>
                        {primaryColumns.map((column) => (
                            <HeaderCell
                                key={column.id}
                                tableStyle={tableStyle}
                                column={column}
                                sort={sort}
                                onSortChange={onSortChange}
                                isCompact
                            />
                        ))}
                        {/* Header for the expand/collapse button */}
                        <StyledHeaderCell $tableStyle={tableStyle ?? 'data'} />
                    </>
                ) : (
                    columns.map((column, columnIndex) => (
                        <HeaderCell
                            key={column.id}
                            tableStyle={tableStyle}
                            column={column}
                            lockStyles={lockStyles[columnIndex]}
                            columnRef={headerRefs[columnIndex]}
                            sort={sort}
                            onSortChange={onSortChange}
                            onResize={onResize}
                        />
                    ))
                )}
            </tr>
        </thead>
    );
}
